import React, { useEffect, useState } from 'react'
import { Banner } from '../Components/Banners'
import { useRequestGet } from '../Hooks';
import { NavLink } from 'react-router-dom';

export const BannersImgs = () => {

  const {data, isLoading, isError} =  useRequestGet('banners/?tipo=BA');

  const [banners, setBanners] = useState([]);

  useEffect(() => {
    try {
      if (data) {
        setBanners( () => JSON.parse(data)?.results )
      }
    } catch (error) {
      console.log(error);
    }
  }, [data])

  return (
    <>
        <Banner
            contentArray={
              banners?.map( (banner) => (
                  <NavLink
                    to={banner.url} 
                    key={banner.uuid}
                  >
                    {card(banner.image, '', 'center')}
                  </NavLink>

              ))
            }
            slidesPerView={3}
            autoplay={true}
            enableCoverFlow={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
        />
    </>
  )
}

const card = (img, title, position, handle = () => {}) => {
  position =
    position === "center" ? "center" : position === "left" ? "start" : "end";

  return (
    <button className="card m-0 p-0" onClick={()=>handle}>
      <img src={img} className="card-img " alt="..." />
      <div className="card-img-overlay h-100">
        <div
          className={`d-flex h-100 mx-5 justify-content-${position} align-items-center`}
        >
          {title && (
            <h5
              className="card-title text-uppercase text-bg-light opacity-75 p-5 rounded rounded-5"
              style={{ fontSize: "5rem" }}
            >
              <span className="text-warning" style={{ fontWeight: "bold" }}>
                {title}
              </span>
            </h5>
          )}
        </div>
      </div>
    </button>
  );
};

